
<div class="warning-notice">
  <div class="background" />
  <div class="main">
    <p class="hold">⚠️Warning: Please Acknowledge⚠️</p>
    <p>There is a problem with your account:</p>
    <p class="has-text-weight-bold" style="padding: 12px 0">
      {{ warningNotice }}
    </p>
    <!-- <p>ontact us if you would like to remove this warning.</p> -->
    <p class="buttons" style="margin: 16px 0">
      <span class="button is-capitalized pulse" @click="close"
        ><i class="fa fa-check-double" />&nbsp;I Acknowledge</span
      >
      <span class="button is-capitalized pulse" @click="emailAboutWarning"
        ><i class="far fa-envelope" />&nbsp;Remove Warning</span
      >
    </p>
  </div>
</div>
